import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { hasAuthorities, firstAccessibleRoute, RESTRICTED_ROUTES } from './utils/authoritiesUtils';

const PrivateRoute = ({ children }) => {
    const token = localStorage.getItem('token');
    const tokenExpiration = localStorage.getItem('tokenExpiration');
    const isTokenExpired = tokenExpiration && new Date().getTime() > tokenExpiration;
    const location = useLocation();

    if (!token || isTokenExpired) {
        // localStorage.removeItem('token');
        // localStorage.removeItem('tokenExpiration');
        // localStorage.removeItem('username');
        localStorage.clear();
        return <Navigate to="/login" />;
    }

    // Table unique route → autorité (partagée avec Login et la page de changement de mot de passe)
    const restrictedRoutes = RESTRICTED_ROUTES;
    

 

    const hasAccess = (route) => {
        const requiredAuthority = restrictedRoutes[route];
        return requiredAuthority ? hasAuthorities(requiredAuthority) : true;
    };

    const restrictedRoute = Object.keys(restrictedRoutes).find(route => location.pathname.startsWith(route));

    if (restrictedRoute && !hasAccess(restrictedRoute)) {
        const accessibleRoute = firstAccessibleRoute();
        // Compte sans aucune autorisation (ex. expert créé sans droits) : rediriger vers /sinistres
        // relancerait ce garde à l'infini → page blanche. On affiche un message à la place.
        if (!accessibleRoute) {
            return (
                <div style={{ padding: 40, fontFamily: 'Poppins, sans-serif', textAlign: 'center' }}>
                    <h2>Aucune autorisation</h2>
                    <p>Votre compte <strong>{localStorage.getItem('username')}</strong> n'a accès à aucune page.</p>
                    <p>Demandez à un administrateur de lui attribuer des autorisations, puis reconnectez-vous.</p>
                    <button type="button" onClick={() => { localStorage.clear(); window.location.assign('/maeassurance/login'); }}>
                        Se déconnecter
                    </button>
                </div>
            );
        }
        return <Navigate to={accessibleRoute} />;
    }

    return children;
};

export default PrivateRoute;
